import { WheelColumn } from './WheelColumn';
import { RoundButton } from './RoundButton';

const PRESETS = [1, 3, 5];

export const CountdownSetup = ({ hms, setHms, onStart, onPreset }) => {
  const [h, m, s] = hms;
  const set = (i) => (v) => setHms((prev) => prev.map((x, j) => (j === i ? v : x)));
  return (
    <div className="flex flex-col items-center w-full" data-testid="countdown-setup">
      <div className="relative flex w-full max-w-[340px] items-end">
        <div className="pointer-events-none absolute inset-x-0 bottom-[48px] h-[48px] rounded-2xl bg-white/[0.04] border border-white/5" />
        <WheelColumn label="Hours" max={99} value={h} onChange={set(0)} testId="wheel-hours" />
        <span className="pb-[56px] text-2xl font-bold text-white/60">:</span>
        <WheelColumn label="Minutes" max={59} value={m} onChange={set(1)} testId="wheel-minutes" />
        <span className="pb-[56px] text-2xl font-bold text-white/60">:</span>
        <WheelColumn label="Seconds" max={59} value={s} onChange={set(2)} testId="wheel-seconds" />
      </div>

      <div className="mt-6 flex flex-wrap justify-center gap-2 w-full">
        {PRESETS.map((min) => (
          <button
            type="button"
            key={min}
            onClick={() => onPreset(min)}
            className="px-3 py-2 rounded-full bg-white/[0.06] border border-white/10 text-xs sm:text-sm font-semibold tabular-nums text-white hover:border-primary/50 hover:text-primary transition-colors"
            data-testid={`countdown-preset-${min}`}
          >
            00:{String(min).padStart(2, '0')}:00
          </button>
        ))}
      </div>

      <div className="mt-8">
        <RoundButton variant="primary" onClick={onStart} disabled={h + m + s === 0} data-testid="countdown-start-btn">
          Start
        </RoundButton>
      </div>
    </div>
  );
};

export default CountdownSetup;
